module.exports = __webpack_public_path__ + "img/laohuang_down_code.11d55603.png";